import React from 'react'

// Local files
import Navbar from '../defaultComponents/Navbar'
import Footer from '../defaultComponents/Footer'
import OrderRequisitionItem from './OrderRequisitionItem'

// Libraries
import styled from 'styled-components'
import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
const PageWrapper = styled.div`
  background: #f8f8f8;
`

const FormBanner = styled.div`
  min-height: 100vh;

  display: flex;
  align-items: center;
  flex-direction: column;
`

const FormTitle = styled.div`
  width: 60vw;

  font-family: Montserrat;
  font-weight: bold;

  font-size: 1.5rem;
`

const FormWrapper = styled.div`
  display: flex;
  background: white;

  border: 1px solid lightgrey;
  border-radius: 5px;

  width: 60vw;

  gap: 1vh;

  flex-direction: column;
`;

const FormSection = styled.div`
  padding: 1vw;
  border-bottom: 1px solid lightgrey;

  display: flex;
  flex-direction: column;
  gap: 1vw;
`

const FormSectionTitle = styled.div`
  font-size: 1rem;

  font-family: Montserrat;
  font-weight: bold;
`

const FormSectionRow = styled.div`
  display: flex;
  gap: 1vw;

  align-items: center;
`

const FormButtonContainer = styled.div`
  display: flex;
  justify-content:center;
  padding: 1vw;
`

const FormButton = styled.button`

  height: 50px;
  width: 500px;
  color: white;

  border: 1px solid tomato;
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 5px;

  font-family: Inter;
  color: tomato;

  background: none;

  &:hover{
    background: tomato;
    color: white;
    transition: 150ms;
  }
`
const createItemFields = () => {
  var fields = []
  for (var i = 0; i < 10; i++) {
    fields.push({
      id: i,
      quantity: "",
      name: "",
      description: "",
      unitPrice: "",
      totalPrice: "",
      notes: ""
    })
  }
  return fields
}

const createRequestFields = () => {
  return {
    requesterName: "",
    requesterDepartment: "",
    requestDate: "",
    supplier: "",
    supplierAddress: "",
    supplierContact: "",
    supplierEmail: "",
    supplierPhone: "",
    paymentMethod: "",
    expeditedDelivery: "",
    deliveryMethod: ""
  }
}

export default function OrderRequistionForm() {

  const [itemList, setItemList] = React.useState(React.useMemo(()=> createItemFields()), [])
  
  const [requesterName, setRequesterName] = React.useState("");
  const [requesterDepartment, setRequesterDepartment] = React.useState("");
  const [requestDate, setRequestDate] = React.useState("");
  const [supplier, setSupplier] = React.useState("");
  const [supplierAddress, setSupplierAddress] = React.useState("");
  const [supplierContact, setSupplierContact] = React.useState("");
  const [supplierEmail, setSupplierEmail] = React.useState("");
  const [supplierPhone, setSupplierPhone] = React.useState("");
  const [paymentMethod, setPaymentMethod] = React.useState("");
  const [deliveryExpedited, setDeliveryExpedited] = React.useState("");
  const [deliveryMethod, setDeliveryMethod] = React.useState("");

  const onInputChange = (index, item) => {
    itemList[index] = item;
  }

  const submitFields = () => {
    console.log(JSON.stringify(requesterName))
  }

  return (
    <>
      <Navbar />
      <PageWrapper>
        <FormBanner>
          <FormTitle>
            Order Requisition Form
          </FormTitle>
          <FormWrapper>
            <FormSection>
              <FormSectionTitle>
                Requester Info
              </FormSectionTitle>
              <FormSectionRow>
                <TextField label="Full Name" variant="outlined" onChange={(e)=>setRequesterName(e.target.value)}/>
                <TextField label="Department" variant="outlined" onChange={(e)=>setRequesterDepartment(e.target.value)}/>
                <TextField label="Date" variant="outlined" onChange={(e)=>setRequestDate(e.target.value)}/>
              </FormSectionRow>
            </FormSection>
            <FormSection>
              <FormSectionTitle>
                Supplier Info
              </FormSectionTitle>
              <FormSectionRow>
                <TextField label="Supplier" variant="outlined" onChange={(e)=>setSupplier(e.target.value)}/>
                <TextField label="Supplier Address" variant="outlined" onChange={(e)=>setSupplierAddress(e.target.value)}/>
              </FormSectionRow>
              <FormSectionRow>
                <TextField label="Supplier Contact (if any)" variant="outlined" onChange={(e)=>setSupplierContact(e.target.value)}/>
                <TextField label="Supplier Contact Email" variant="outlined" onChange={(e)=>setSupplierEmail(e.target.value)}/>
                <TextField label="Supplier Contact Phone" variant="outlined" onChange={(e)=>setSupplierPhone(e.target.value)}/>
              </FormSectionRow>
            </FormSection>
            <FormSection>
              <FormSectionTitle>
                Payment and Delivery Details
              </FormSectionTitle>
              <FormSectionRow>
                <TextField label="Payment Method" variant="outlined" onChange={(e)=>setPaymentMethod(e.target.value)}/>
                <TextField label="Expedited Delivery?" variant="outlined" onChange={(e)=>setDeliveryExpedited(e.target.value)}/>
                <TextField label="Preferred Delivery Method" variant="outlined" onChange={(e)=>setDeliveryMethod(e.target.value)}/>
              </FormSectionRow>
            </FormSection>
            <FormSection>
              <FormSectionTitle>
                Product/Service Requested
              </FormSectionTitle>
              {itemList.map((item, idx) => (
                <OrderRequisitionItem 
                  key={item.id}
                  itemData={item}
                  index={idx}
                  syncParent = {onInputChange}
                />
              ))}
            </FormSection>
            <FormButtonContainer>
              <FormButton onClick={submitFields}>SUBMIT REQUEST
                <ArrowUpwardIcon />
              </FormButton>
            </FormButtonContainer>
          </FormWrapper>
          
        </FormBanner>
        <Footer />
      </PageWrapper>

    </>
  )
}
